/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner';

export class AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner {
  /**
  * Name of the global secondary index.
  */
  'indexName'?: string | null;
  /**
  * The complete key schema for the global secondary index.
  */
  'keySchema'?: Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner>;
  'projection'?: AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection | null;
  'onDemandThroughput'?: AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput | null;
  'provisionedThroughput'?: AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput | null;
  'warmThroughput'?: AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput | null;
  /**
  * Total size of the specified index, in bytes.
  */
  'indexSizeBytes'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "indexName",
      "baseName": "indexName",
      "type": "string",
      "format": ""
    },
    {
      "name": "keySchema",
      "baseName": "keySchema",
      "type": "Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner>",
      "format": ""
    },
    {
      "name": "projection",
      "baseName": "projection",
      "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection",
      "format": ""
    },
    {
      "name": "onDemandThroughput",
      "baseName": "onDemandThroughput",
      "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput",
      "format": ""
    },
    {
      "name": "provisionedThroughput",
      "baseName": "provisionedThroughput",
      "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput",
      "format": ""
    },
    {
      "name": "warmThroughput",
      "baseName": "warmThroughput",
      "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput",
      "format": ""
    },
    {
      "name": "indexSizeBytes",
      "baseName": "indexSizeBytes",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

